angular.module('obto.data.performance', ['obto.data.service'])
    .controller('PerformanceController', ['$scope', '$http', 'pageService', '$routeParams', '$log','$rootScope', '_', function ($scope, $http, pageService, $routeParams, $log, $rootScope, _) {

        $scope.greeting = "Resize the page to see the re-rendering";

        $scope.slabel = false;

        $scope.instance_name = $routeParams.instance_name + '';//"GESandbox1";

        $log.log('PerformanceController' + $routeParams.thisIsLast);
        $log.log('PerformanceController' + JSON.stringify($routeParams));

        var data = [];


        // var data = [{"name":"List Views","y":53.61,"drilldown":"Microsoft Internet Explorer "},{"name":"Reports ","y":18.73,"drilldown":"Chrome "},{"name":"Ajax Requests ","y":19.899999999999995,"drilldown":"Firefox "},{"name":"Scheduled Jobs ","y":4.64,"drilldown":"Safari "},{"name":"Homepages ","y":1.54,"drilldown":"Opera "},{"name":"SOAP","y":0.29,"drilldown":null}];

        //var drilldownData = [{
        //    "name": "Microsoft Internet Explorer ",
        //    "id": "Microsoft Internet Explorer ",
        //    "data": [["v8.0", 26.61], ["v9.0", 16.96], ["v6.0", 6.4], ["v7.0", 3.55], ["v8.0", 0.09]]
        //}, {
        //    "name": "Chrome ",
        //    "id": "Chrome ",
        //    "data": [["v18.0", 8.01], ["v19.0", 7.73], ["v17.0", 1.13], ["v16.0", 0.45], ["v18.0", 0.26], ["v14.0", 0.25], ["v20.0", 0.24], ["v15.0", 0.18], ["v12.0", 0.16], ["v13.0", 0.13], ["v11.0", 0.1], ["v10.0", 0.09]]
        //}, {
        //    "name": "Firefox ",
        //    "id": "Firefox ",
        //    "data": [["v12", 6.72], ["v11", 4.72], ["v13", 2.16], ["v3.6", 1.87], ["v10", 0.9], ["v9.0", 0.65], ["v8.0", 0.55], ["v4.0", 0.5], ["v3.0", 0.36], ["v3.5", 0.36], ["v6.0", 0.32], ["v5.0", 0.31], ["v7.0", 0.29], ["v14", 0.1], ["v2.0", 0.09]]
        //}, {
        //    "name": "Safari ",
        //    "id": "Safari ",
        //    "data": [["v5.1", 3.53], ["v5.0", 0.85], ["v4.0", 0.14], ["v4.1", 0.12]]
        //}, {"name": "Opera ", "id": "Opera ", "data": [["v11.x", 1.3], ["v12.x", 0.15], ["v10.x", 0.09]]}];

        $scope.chartSeries = [{
            "name": "Slow Query Groups",
            colorByPoint: false,
            "data": data
        }];

        $scope.chartConfig = [{
            options: {
                chart: {
                    type: 'column'//, //'areaspline',
                    //animation: false
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '8px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: 'Count of slow query types'
                    }
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:.1f}%'
                        }
                    }
                }//,
                //drilldown: {
                //    series: drilldownData
                //}
            },
            series: $scope.chartSeries,
            title: {
                text: 'Slow Queries - Group by type'
            },
            credits: {
                enabled: false
            },
            loading: false,
            size: {}
        },
            {
                options: {
                    chart: {
                        type: 'area' //'areaspline'
                    },
                    plotOptions: {
                        series: {
                            stacking: ''
                        }
                    }
                },
                series: $scope.chartSeries,
                title: {
                    text: 'Hello'
                },
                credits: {
                    enabled: false
                },
                loading: false,
                size: {}
            },
            {
                "options": {
                    "chart": {
                        "type": "column"
                    },
                    "plotOptions": {
                        "series": {
                            "stacking": ""
                        }
                    }
                },
                "series": ["schedule_query", "homepage_query", "report_query", "SOAP", "Ajax"],
                "title": {
                    "text": "Slow SQL By Category"
                },
                "credits": {
                    "enabled": false
                },
                "loading": false,
                "size": {}
            }, {
                options: {

                    chart: {
                        type: 'gauge',
                        plotBackgroundColor: null,
                        plotBackgroundImage: null,
                        plotBorderWidth: 0,
                        plotShadow: false
                    },
                    yAxis: {
                        min: 0,
                        max: 100,

                        minorTickInterval: 'auto',
                        minorTickWidth: 1,
                        minorTickLength: 10,
                        minorTickPosition: 'inside',
                        minorTickColor: '#666',

                        tickPixelInterval: 30,
                        tickWidth: 2,
                        tickPosition: 'inside',
                        tickLength: 10,
                        tickColor: '#666',
                        labels: {
                            step: 2,
                            rotation: 'auto'
                        },
                        title: {
                            text: '%'
                        },
                        plotBands: [{
                            from: 0,
                            to: 50,
                            color: '#55BF3B' // green
                        }, {
                            from: 50,
                            to: 75,
                            color: '#DDDF0D' // yellow
                        }, {
                            from: 75,
                            to: 100,
                            color: '#DF5353' // red
                        }]
                    },
                    pane: {
                        startAngle: -150,
                        endAngle: 150,
                        background: [{
                            backgroundColor: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, '#FFF'],
                                    [1, '#333']
                                ]
                            },
                            borderWidth: 0,
                            outerRadius: '109%'
                        }, {
                            backgroundColor: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, '#333'],
                                    [1, '#FFF']
                                ]
                            },
                            borderWidth: 1,
                            outerRadius: '107%'
                        }, {
                            // default background
                        }, {
                            backgroundColor: '#DDD',
                            borderWidth: 0,
                            outerRadius: '105%',
                            innerRadius: '103%'
                        }]
                    }
                },

                title: {
                    text: 'CPU'
                },

                series: [{
                    name: 'Utilization',
                    data: [80],
                    tooltip: {
                        valueSuffix: ' %'
                    }
                }]


                //}
            }, {
                options: {

                    chart: {
                        type: 'solidgauge'
                    },
                    pane: {
                        center: ['50%', '85%'],
                        size: '100%',
                        startAngle: -90,
                        endAngle: 90,
                        background: {
                            backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || '#EEE',
                            innerRadius: '60%',
                            outerRadius: '100%',
                            shape: 'arc'
                        }
                    },
                    yAxis: {
                        stops: [
                            [0.1, '#55BF3B'], // green
                            [0.5, '#DDDF0D'], // yellow
                            [0.9, '#DF5353'] // red
                        ],
                        lineWidth: 0,
                        minorTickInterval: null,
                        tickPixelInterval: 400,
                        tickWidth: 0,
                        title: {
                            y: -70
                        },
                        labels: {
                            y: 16
                        },
                        min: 0,
                        max: 100//,
                        // title: {
                        //     text: 'Memory'
                        // }
                    },
                    plotOptions: {
                        solidgauge: {
                            dataLabels: {
                                y: 5,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    }
                },
                //title: "Memory",

                title: {
                    text: 'Memory'
                },

                tooltip: {
                    enabled: false
                },

                credits: {
                    enabled: false
                },
                // the value axis

                series: [{
                    name: 'memory',
                    data: [45],
                    dataLabels: {
                        format: '<div style="text-align:center"><span style="font-size:25px;color:' +
                        ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y}</span><br/>' +
                        '<span style="font-size:12px;color:silver">%</span></div>'
                    },
                    tooltip: {
                        valueSuffix: ' %'
                    }
                }]
                //}

            }];

        var fetchData = function (chartConfig) {
            var series = [];
            _.each(chartConfig.series, function (val) {

                pageService.getbydata(val.trim(), function (_data) {

                    series.push({"name": val, "data": _data});// = _data;

                });

            });

            $scope.chartConfig[2].series = series;
        };

        fetchData($scope.chartConfig[2]);

        var xecuteThis = function (chartConfig, scope) {

            setInterval(function () {
                // Speed
                var chart = $('#cpu').highcharts(),
                    point,
                    newVal,
                    inc;

                if (chart) {
                    point = chart.series[0].points[0];
                    inc = Math.round((Math.random() - 0.5) * 100);
                    newVal = point.y + inc;

                    if (newVal < 0 || newVal > 100) {
                        newVal = point.y - inc;
                    }

                    point.update(newVal);
                }

                // RPM
                chart = $('#memory').highcharts();
                if (chart) {
                    point = chart.series[0].points[0];
                    inc = Math.round((Math.random() - 0.5) * 100);
                    newVal = point.y + inc;

                    if (newVal < 0 || newVal > 100) {
                        newVal = point.y - inc;
                    }

                    point.update(newVal);
                }
            }, 2000);

        };

        //xecuteThis($scope.chartConfig, $scope);

        //pageService.get(function (_data) {
        //    // var chart = $('#site-stats').highcharts();
        //    // chart.series[0].remove();
        //    // chart.addSeries({ data : _data});
        //    // console.log(_data);
        //
        //    var chart2 = $('#site-stats2').highcharts();
        //    chart2.series[0].remove();
        //    chart2.addSeries({data: _data});
        //    //console.log(_data);
        //    //data = _data;
        //    //$scope.chartSeries[0].data = _data;
        //});

        if (_.isUndefined($rootScope.socket))
            socket.then(function() {

                $log.log("Ready for socket connections");

                $rootScope.socket.on('connect', function() {
                    $log.log($rootScope.socket.io.engine.id);

                });

                executeSocketCalls($scope.chartConfig, $scope);

            });
        else
            executeSocketCalls($scope.chartConfig, $scope);


        function executeSocketCalls(chartConfig, scope) {

            console.log("Preparing to recieve on : " + 'sn.stats.' + $scope.instance_name.toLowerCase());
            $rootScope.socket.on('sn.stats.' + $scope.instance_name.toLowerCase(), function(data) {
                ///console.log()
                data = JSON.parse(JSON.stringify(data));
                //console.log(JSON.parse(JSON.stringify(data))[0]);
                //console.log(_.findWhere(JSON.parse(JSON.stringify(data)), { label :"CPU(24) load average(1 min)"}).value);
                //console.log(_.findWhere(JSON.parse(JSON.stringify(data)), { label :"Percent free memory of Max"}).value);

                var chart = $('#cpu').highcharts(),
                    point,
                    newVal,
                    inc;

                if (chart) {
                    point = chart.series[0].points[0];
                    inc = Math.round((Math.random() - 0.5) * 100);
                    newVal = point.y + inc;

                    if (newVal < 0 || newVal > 100) {
                        newVal = point.y - inc;
                    }

                    point.update(parseInt(_.findWhere(data, { label :"CPU(24) load average(1 min)" }).value) );//CPU(24) load average(1 min)
                }

                // RPM
                chart = $('#memory').highcharts();
                if (chart) {
                    point = chart.series[0].points[0];
                    inc = Math.round((Math.random() - 0.5) * 100);
                    newVal = point.y + inc;

                    if (newVal < 0 || newVal > 100) {
                        newVal = point.y - inc;
                    }

                    point.update(parseInt(_.findWhere(data, { label :"Percent free memory of Max" }).value));//Percent free memory of Max
                }
            });
        }

        var data = [],
            totalPoints = 200;


        $scope.getRows = function (n) {


            return new Array(parseInt(n));
        };

        $scope.getColumns = function (n) {

            return new Array(parseInt(n));
        };

        $scope.refresh = function(){
            $scope.$apply(function () {
                $scope.timenow =  new Date().getTime();
            });
        };

        function getRandomData() {
            if (data.length > 0)
                data = data.slice(1);

            // do a random walk
            while (data.length < totalPoints) {
                var prev = data.length > 0 ? data[data.length - 1] : 50;
                var y = prev + Math.random() * 10 - 5;
                if (y < 0)
                    y = 0;
                if (y > 100)
                    y = 100;
                data.push(y);
            }

            // zip the generated y values with the x values
            var res = [];
            for (var i = 0; i < data.length; ++i)
                res.push([i, data[i]]);
            return res;
        }

    }]);
